import { Fragment } from 'react';
import { ReactComponent as Star } from '../images/star.svg';

type Frequency = {
    [key: string]: number
};
type Props = {
    dailyId: number
}

const DailyStatistics = ({ dailyId }: Props): JSX.Element => {
    const stats = JSON.parse(localStorage.getItem('stats') || '[]');
    const summary = JSON.parse(localStorage.getItem('summary') || '{}');
    const frequency: Frequency = {'-1': 0, '1': 0, '2': 0, '3': 0};

    stats.forEach((result: Record<string, number>): void => {
        const score = result.s;

        frequency[score] ++;
    });

    const mostFrequent = (Object.entries(frequency) as Array<[string, number]>).sort((a, b) => b[1] - a[1])[0];
    const recentResult = stats.find((stat: Record<string, number>) => stat.p === dailyId);
    
    const getClassName = (index: number): string => {
        if (recentResult && recentResult.s === index) {
            return 'bar recent';
        }

        return 'bar';
    };

    return (
        <>
            <div className="summary">
                <div className="summary-row">
                    <div className="label">Played</div>
                    <div className="value">{summary.g}</div>
                </div>
                <div className="summary-row">
                    <div className="label">Total Stars</div>
                    <div className="value">{summary.s}</div>
                </div>
                <div className="summary-row">
                    <div className="label">Current Streak</div>
                    <div className="value">{summary.c}</div>
                </div>
                <div className="summary-row">
                    <div className="label">Best Streak</div>
                    <div className="value">{summary.b}</div>
                </div>
            </div>
            <h4 className="distribution">Star Distribution</h4>
            <div className="distribution-container">
                <div className="rating">X</div>
                <div className="proportion">
                    <div className={getClassName(-1)} style={{width: `${frequency[-1] / mostFrequent[1] * 100}%`}}>{frequency[-1]}</div>
                </div>
                <div className="percentage">{frequency[-1] > 0 && `${Math.round(frequency[-1] / summary.g * 100)}%`}</div>
                {[...Array(3).keys()].map(k => (
                    <Fragment key={k}>
                        <div className="rating">{k + 1}<Star /></div>
                        <div className="proportion">
                            <div className={getClassName(k + 1)} style={{width: `${frequency[k + 1] / mostFrequent[1] * 100}%`}}>{frequency[k + 1]}</div>
                        </div>
                        <div className="percentage">{frequency[k + 1] > 0 && `${Math.round(frequency[k + 1] / summary.g * 100)}%`}</div>
                    </Fragment>
                ))}
            </div>
        </>
    );
}

export default DailyStatistics;
